<template>
  <base-section
    id="map"
    space="0"
  >
    <iframe
      allowfullscreen
      aria-hidden="false"
      frameborder="0"
      height="500"
      src="https://maps.google.com/maps?q=Helderberg%20Propshaft&t=m&z=13&output=embed&iwloc=near"
      style="border:0; display: block;"
      tabindex="0"
      width="100%"
    />
  </base-section>
</template>

<script>
export default {
  name: 'SectionMap',

  provide: {
    heading: { align: 'center' },
  },
};
</script>
